import { render, staticRenderFns } from "./OrderCreditNoteItems.vue?vue&type=template&id=5b96c61c&scoped=true&"
import script from "./OrderCreditNoteItems.vue?vue&type=script&lang=ts&"
export * from "./OrderCreditNoteItems.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCreditNoteItems.vue?vue&type=style&index=0&id=5b96c61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96c61c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
